import { $t } from '@/lang'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'

interface AxiosResponseConfig extends AxiosResponse {
  config: AxiosRequestConfig
}

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : 'https://authentication.cirroparcel.com',
  timeout: 10000
})

const popErrorMessage = (message: string) => {
  ElMessage({ message, type: 'error', customClass: 'zIndex-6666' })
}

request.interceptors.response.use((response: AxiosResponseConfig) => {
  return response
}, async (error) => { // 超出 2xx 的状态码
  const errFormat = {
    message: '',
    tips: '',
    status: null
  }
  if (error.response) { // 请求发出收到响应，但是状态码超出 2xx 范围
    const { status, data } = error.response
    errFormat.message = (data as any).tips || (data as any).display || $t('main_request_tip_server_error')
    errFormat.status = status
    if (status === 400) {
      popErrorMessage(errFormat.message)
    } else if (status === 403) {
      popErrorMessage($t('main_request_tip_no_legal'))
    } else if (status === 409) {
      popErrorMessage(errFormat.message)
    } else if (status >= 500) {
      popErrorMessage($t('main_request_tip_server_error'))
    }
  } else if (error.request) {
    popErrorMessage($t('main_request_tip_timeout'))
  }
  return Promise.reject(errFormat)
})

export default request
